import React from 'react';
import strings from '../../lang/strings.js';
import $ from 'jquery';
import { PageSettings } from "../../config/page-settings";
import DataTable from './../../components/content/data-table.jsx';
import './../../config/util';
import Const from './../../config/const';
import U from './../../config/util';

class MemberCandidate extends React.Component {
    static contextType = PageSettings;

    constructor(props) {
        super(props);

        this.state = {};
    }

    componentDidMount() {
    }

    render() {
        let self = this;
        let user_info = this.props.user_info;
        let columnNo = 0;

        return (
            <div>
                <div className="row">
                    <div className="col-xs-3">
                        <div className='row'>
                            <label>{strings.birthday}: {U.birth2Age(user_info.birthday)}</label>
                        </div>
                    </div>
                    <div className="col-xs-3">
                        <div className='row'>
                            <label>{strings.height}: {user_info.height}cm</label>
                        </div>
                    </div>
                    <div className="col-xs-6">
                        <div className='row'>
                            <label>{strings.location}: {user_info.location}</label>
                        </div>
                    </div>
                </div>
                <div className="row mt-2">
                    <DataTable ref={(ref) => this.tblMember = ref}
                        options={{
                            columnDefs: [
                                {
                                    targets: [columnNo++], data: 'id', orderable: false,
                                    render: function (value) {
                                        return value
                                    }
                                },
                                {
                                    targets: [columnNo++], data: 'profile_image', orderable: false,
                                    createdCell: function (td, value, item) {
                                        return $(td).image_lightbox(value, () => {
                                            self.context.showGallery(value.split('#').map((it) => { return Const.BASE_URL + it }))
                                        });
                                    }
                                },
                                {
                                    targets: [columnNo++], data: 'user_id', orderable: false,
                                    createdCell: function (td, value, item) {
                                        $(td).html(item.nickname);
                                    }
                                },
                                {
                                    targets: [columnNo++], data: 'id', orderable: false,
                                    createdCell: function (td, value, item) {
                                        $(td).html(
                                            item.gender.gender2String() + ' ' +
                                            U.birth2Age(item.birthday) + '세 <br/>' +
                                            item.height + 'cm ' +
                                            (item.location.split(",").length > 0 ? item.location.split(",")[0] : item.location)
                                        );
                                    }
                                },
                                {
                                    targets: [columnNo++], data: 'vip', orderable: false,
                                    render: function (value) {
                                        if (value == 'Y') {
                                            return value;
                                        } else {
                                            return '-';
                                        }
                                    }
                                },
                                {
                                    targets: [columnNo++], data: 'status', orderable: false,
                                    render: function (value) {
                                        return Number(value).status2String();
                                    }
                                },
                            ],
                            iDisplayLength: 10,
                            order: [[1, 'DESC']],
                            ajax: {
                                url: 'member/getCandidateList',
                                data: function (req) {
                                    req.columns = null;
                                    req.uid = user_info.id;
                                }
                            },
                            drawCallback: function () {
                            },
                            fnCreatedRow: function (row, data, dataInd) {
                            }
                        }}>
                        <thead>
                            <tr>
                                <th>UID</th>
                                <th>{strings.profile}</th>
                                <th>{strings.nickname}</th>
                                <th>{strings.gender}, {strings.birthday}<br />{strings.height}, {strings.location}</th>
                                <th>VIP</th>
                                <th>{strings.status}</th>
                            </tr>
                        </thead>
                        <tbody />
                    </DataTable>
                </div>
            </div >
        )
    }
}

export default MemberCandidate;